package game.entity

import game.Game
import game.Room
import game.controller.GameController
import game.controller.ScriptController

open class Npc(val spriteId: String?, val wander: Boolean) : Entity() {
    private val wanderComponent = WanderComponent(20, true)

    override fun onInit(game: Game, room: Room) {
        if (spriteId != null) {
            sprite = game.getSpriteById(spriteId)
        }
    }

    override fun onTick(game: Game, room: Room) {
        if (wander) {
            wanderComponent.tick(game, room, this)
        }
    }

    override fun onCollideWithPlayer(game: Game, room: Room): Boolean {
        game.showDialog(params)

        return false
    }
}

class ScriptNpc(spriteId: String?, wander: Boolean, val script: List<(Game) -> GameController>) : Npc(spriteId, wander) {
    override fun onCollideWithPlayer(game: Game, room: Room): Boolean {
        val scriptController = ScriptController(script)

        game.controller = scriptController

        return spriteId == null
    }
}